export const SETTLEMENT_STATUSES = {
    UNSETTLED: 'Unsettled',
    HOLD: 'Hold',
    SETTLED: 'Settled',
    INITIATED: 'Initiated'
  
} as const;

export type SettlementStatus = keyof typeof SETTLEMENT_STATUSES;

export const getSettlementStatusColor = (status: SettlementStatus): string => {
  switch (status) {
    case 'SETTLED':
      return 'success';
    case 'HOLD':
      return 'warning';
    case 'UNSETTLED':
      return 'error';
    default:
      return 'default';
  }
};
